<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-surgeries-assigned-list />
